// extracted by mini-css-extract-plugin
export default {"card":"Card_card__kqkdJ","card_header":"Card_card_header__vii-X","title":"Card_title__Sxo4H"};